import produce from "immer";

import { Action, actionCreators } from "../actions";
import { RootState } from "../reducers";
import { Data } from "../service/Data";

export type Notification = Data.Notify & { id: string };

const MAX_NOTIFICATIONS_OPEN = 3;

const initialStore = {
    permission: undefined as NotificationPermission | undefined,
    notifications: [] as Data.Notify[],
    newNotification: 0,
};

type Store = Readonly<typeof initialStore>;

export const update = produce((draft, action: Action): Store | void => {
    if (
        action.type === actionCreators.onWrongToken.type ||
        action.type === actionCreators.onLogout.type
    ) {
        return initialStore;
    } else if (action.type === actionCreators.onNotify.type) {
        const { data, ignore } = action.payload;
        draft.newNotification++;
        if (!ignore) {
            draft.notifications = [
                ...draft.notifications.slice(-(MAX_NOTIFICATIONS_OPEN - 1)),
                data,
            ];
        }
    } else if (action.type === actionCreators.onNotificationClosed.type) {
        const { roomId, ts } = action.payload;
        const newNotifications = draft.notifications.filter(
            x => !(x.room_id === roomId && x.text_ts <= ts)
        );
        if (draft.notifications.length !== newNotifications.length) {
            draft.notifications = newNotifications;
        }
    } else if (action.type === actionCreators.setNotificationPermission.type) {
        draft.permission = action.payload;
    }
}, initialStore);

export type OuterStore = { notifications: Store };

export function getPermission(store: OuterStore) {
    return store.notifications.permission;
}

export function getNotifications(store: RootState) {
    return store.notifications.notifications;
}

export function getNewNotification(store: RootState) {
    return store.notifications.newNotification;
}
